import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link, useParams } from 'react-router-dom'
import { getProductDetail } from '../api/catalog'
import type { ProductDetailResponse } from '../api/types'
import Loading from '../components/Loading'

const SPEC_LABELS: Record<string, string> = {
  code: 'Artikel No',
  barkod: 'BARKOD',
  oem: 'OEM',
  mann: 'MANN',
  wunder: 'WUNDER',
  gramaj: 'Gramaj',
  numberofboxes: 'Paket Adedi',
  unit: 'Birim',
  measure: 'Ölçü',
  stock: 'Stok',
  perbox: 'Koli Adedi',
}

export default function ProductDetailPage() {
  const { slug } = useParams<{ slug: string }>()
  const [data, setData] = useState<ProductDetailResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!slug) return
    setData(null)
    getProductDetail(slug)
      .then(setData)
      .catch((err: Error) => setError(err.message))
  }, [slug])

  if (error) return <p className="error container section">{error}</p>
  if (!data) return <Loading />

  const { product, related_products: relatedProducts } = data

  return (
    <div className="container section product-detail-page">
      <Helmet>
        <title>{product.seo.title ?? product.title ?? 'Helmach'}</title>
        {product.seo.description && (
          <meta name="description" content={product.seo.description} />
        )}
      </Helmet>

      <nav className="breadcrumb">
        <Link to="/">Anasayfa</Link> / {product.title}
      </nav>

      <div className="product-info">
        <img src={product.image} alt={product.title ?? ''} />
        <div>
          <h1>{product.title}</h1>
          <ul className="product-meta">
            {(Object.keys(SPEC_LABELS) as Array<keyof typeof SPEC_LABELS>).map((key) => {
              const value = product[key as keyof typeof product]
              if (!value) return null
              return (
                <li key={key}>
                  <strong>{SPEC_LABELS[key]}:</strong> {String(value)}
                </li>
              )
            })}
          </ul>
        </div>
      </div>

      {product.content && (
        <div className="product-description" dangerouslySetInnerHTML={{ __html: product.content }} />
      )}

      {relatedProducts.length > 0 && (
        <section className="related-products">
          <h2>Benzer Ürünler</h2>
          <div className="product-grid">
            {relatedProducts.map((related) => (
              <Link key={related.id} to={`/urunlerimiz/${related.slug}`} className="product-card">
                <img src={related.image} alt={related.title ?? ''} />
                <h3>{related.title}</h3>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  )
}
